import { EAdBannerSize } from '@/components/AdBanner/AdBanner.types';
import { useEffect, useState } from 'react';

const sizeConditions = {
  [EAdBannerSize.Tall]: (screenWidth: number) => screenWidth > 1040,
  [EAdBannerSize.Square]: (screenWidth: number) => screenWidth > 1040,
  [EAdBannerSize.Wide]: (screenWidth: number) => screenWidth > 1100,
  [EAdBannerSize.Small]: (screenWidth: number) => screenWidth < 600,
};

export const useShouldDisplayBanner = (
  size: EAdBannerSize,
  hideAtWidth?: number,
  hideAtHeight?: number,
) => {
  // Start with true to avoid SSR mismatch - CSS will handle hiding on mobile
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1920,
  );
  const [screenHeight, setScreenHeight] = useState<number>(
    typeof window !== 'undefined' ? window.innerHeight : 1080,
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (
    (hideAtWidth && screenWidth <= hideAtWidth) ||
    (hideAtHeight && screenHeight < hideAtHeight)
  ) {
    return false;
  }

  const condition = sizeConditions[size];
  return condition ? condition(screenWidth) : true;
};
